import {
  paymentsAutoStartSubscriptionMutationKey,
  paymentsChangeSubscriptionPlanMutationKey,
} from '@repo/studio-hooks-coins/gen/coins'
import { useIsMutating } from '@tanstack/react-query'

export function useCoinPlanMutationPending() {
  const isMutatingAutoStart = useIsMutating({
    mutationKey: [paymentsAutoStartSubscriptionMutationKey],
  })
  const isMutatingSwap = useIsMutating({ mutationKey: [paymentsChangeSubscriptionPlanMutationKey] })
  return isMutatingAutoStart > 0 || isMutatingSwap > 0
}
